import Header from "src/Component/content-component/Header";
import ParaData from "src/Component/content-component/ParaData";
import ContentContainer from "src/Component/grid-component/ContentContainer";
import ImageContainer from "src/Component/grid-component/ImageContainer";
import MainContainer from "src/Component/grid-component/MainContainer";
import mbbsImg1 from "../asset/whatismbbs.png";
import { createTheme, useMediaQuery } from "@material-ui/core";
const WhatisMbbs = () => {
  const points = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1600,
      },
    },
  });
  const screenFor = useMediaQuery(points.breakpoints.between("xs", "sm"));

  return (
    <>
      <MainContainer
        com1={
          <ContentContainer
            Header={<Header content={"What is MBBS?"} />}
            Content={
              <ParaData
                color={"#525560"}
                fontSize={"16px"}
                content={
                  "MBBS, or Bachelor of Medicine, Bachelor of Surgery, is an undergraduate degree program that prepares students for a career in medicine and surgery. It is a rigorous and rewarding journey that equips students with the medical knowledge, clinical skills, and ethical foundation necessary to become competent and compassionate physicians."
                }
                textAlign={screenFor ? "left" : null}
              />
            }
          />
        }
        com2={<ImageContainer img={mbbsImg1} />}
      />
    </>
  );
};
export default WhatisMbbs;
